import { Button } from "@/components/ui/button";

/**
 * Slim top bar. It does not reload on its own — a note can stay open until
 * the user presses Vernieuwen.
 */
export function AppUpdateBar({
  open,
  onRefresh,
  ready = true,
}: {
  open: boolean;
  onRefresh: () => void;
  /** False until the service worker listener is attached. */
  ready?: boolean;
}) {
  if (!open) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[80] flex items-center justify-center gap-3 border-b border-border bg-card/95 px-3 py-2 text-sm text-foreground shadow-sm backdrop-blur-sm"
    >
      <p>Nieuwe versie beschikbaar</p>
      <Button type="button" size="sm" disabled={!ready} onClick={onRefresh}>
        Vernieuwen
      </Button>
    </div>
  );
}
